import clsx from "clsx";
import { forwardRef, useEffect, useState } from "react";

interface Props {
  className?: string;
  name?: string;
  label: string,
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  ariaLabel?: string;
}

const ToggleInput = forwardRef<HTMLInputElement, Props>((
  {
    label,
    className = null,
    name = null,
    checked = false,
    onChange = () => {
    },
    ariaLabel = undefined
  }, ref
) => {
  const [isChecked, setIsChecked] = useState<boolean>(checked);

  useEffect(() => {
    onChange(isChecked);
  }, [isChecked]);

  useEffect(() => {
    setIsChecked(checked);
  }, [checked]);

  return (

    <div
      className={clsx("inline-flex items-center cursor-pointer", className)}>

      <label className="inline-flex items-center cursor-pointer">
        <input
          type="checkbox"
          name={name}
          id={name}
          checked={isChecked}
          onChange={(e) => setIsChecked(e.target.checked)}
          ref={ref}
          className="sr-only peer"
          aria-label={ariaLabel}
        />
        <div
          className="relative w-11 h-6 bg-gray-200 rounded-full peer peer-focus:ring-3 peer-focus:ring-primary-300 dark:peer-focus:ring-primary-800 dark:bg-gray-500 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-primary-600 dark:peer-checked:bg-primary-600"></div>
        <span className="ms-3 text-sm font-medium text-gray-900 dark:text-gray-300">
          {label}
        </span>
      </label>
    </div>
  )
    ;
});

export default ToggleInput;